import React from 'react';
import { hot } from 'react-hot-loader/root';
import { QueryCache, ReactQueryCacheProvider } from 'react-query';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowRight,
  faCircleNotch,
  faExclamationTriangle,
  faFolder,
} from '@fortawesome/free-solid-svg-icons';

import './styles/tailwind.css';
import './styles/app.css';
import './styles/form.css';
import { NotificationProvider } from './context/NotificationProvider';
import Navbar from './components/navbar';
import AppRouter from './routes';

const queryCache = new QueryCache();
library.add(faCircleNotch, faFolder, faArrowRight, faExclamationTriangle);

const App = () => {
  return (
    <ReactQueryCacheProvider queryCache={queryCache}>
      <NotificationProvider>
        <Navbar />
        <main className="relative max-w-screen-lg m-auto">
          <AppRouter />
        </main>
      </NotificationProvider>
    </ReactQueryCacheProvider>
  );
};

export default hot(App);
